import { render, staticRenderFns } from "./VSubOrderRefund.vue?vue&type=template&id=11706478&scoped=true"
import script from "./VSubOrderRefund.vue?vue&type=script&lang=ts"
export * from "./VSubOrderRefund.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11706478",
  null
  
)

export default component.exports